export const normalizeUserType = (value?: string) =>
  String(value ?? '')
    .trim()
    .toLowerCase()
    .replace(/[\s_-]+/g, '');

const INDIVIDUAL_USER_TYPES = new Set(['missionary', 'pastor', 'staff', 'private', 'individual']);

export const isIndividualUserType = (value?: string) => {
  return INDIVIDUAL_USER_TYPES.has(normalizeUserType(value));
};
